// extracted by mini-css-extract-plugin
module.exports = {"comparisonSliderItem":"Item_comparisonSliderItem__BRbQH","comparisonSliderItemTarget":"Item_comparisonSliderItemTarget__6_0_Y"};